import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";

import useDebounce from "../../hooks/useDebounce";
import useSearchProducts from "../../hooks/useSearchProducts";
import useStore from "../../store/search-store";
import ProductListing from "../ProductListing";
import { SearchInput } from "./SearchInput";

const SearchSidebar = ({ isOpen, toggleDrawer, store, searchRef }) => {
  const [rawSearchValue, setRawSearchValue] = useState("");
  const { setShouldSearchReopen } = useStore((state) => ({
    setShouldSearchReopen: state.setShouldSearchReopen,
  }));

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const interval = setInterval(() => {
      if (searchRef.current) {
        setRawSearchValue(searchRef.current.getValue());
      }
    }, 200);

    // eslint-disable-next-line no-undef
    return () => clearInterval(interval);
  }, []);
  const debouncedSearch = useDebounce(rawSearchValue, 500);

  const storeProductsQueryProps = useSearchProducts(store.id, "all", debouncedSearch);
  const { isFetching, scrollPosition, setScrollPosition } = storeProductsQueryProps;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <aside
      className={`fixed right-0 top-0 z-[101] h-screen w-screen transform overflow-y-auto bg-background text-fontBackground shadow-lg transition-transform ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex flex-col py-8">
        <div className="flex items-center px-6">
          <span className="text-xl font-bold text-primary">Search</span>

          {/* close button */}
          <button
            className="absolute right-5 top-8 z-50 inline-block w-fit border-0 bg-transparent"
            onClick={() => {
              toggleDrawer();
              setShouldSearchReopen(null);
            }}
            aria-label="Close Search Sidebar"
          >
            <IoMdClose size={30} className="text-primary" />
          </button>
        </div>

        <div className="mt-5 px-6">
          <SearchInput isLoading={isFetching} ref={searchRef} />
        </div>

        {debouncedSearch.length > 2 && (
          <ProductListing
            store={store}
            storeProductsQueryProps={storeProductsQueryProps}
            search
            wrapperClassName="pt-2 overflow-x-hidden overflow-y-auto hide-scrollbar h-[80vh] md:w-[550px] md:mx-auto"
            useVirtualizer
            searchQuery={debouncedSearch}
            toggleDrawer={toggleDrawer}
            setScrollPosition={setScrollPosition}
            scrollPosition={scrollPosition}
          />
        )}
      </div>
    </aside>
  );
};

export default SearchSidebar;
